import { Injectable } from '@angular/core';
import { ColumnsState } from '@app/library/states/columns.state';
import { FiltersState } from '@app/library/states/filters.state';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import { SelectedTracksState } from '@app/library/states/selected-tracks.state';
import { TrackMixPointsState } from '@app/library/states/track-mix-points.state';
import { TracksState } from '@app/library/states/tracks.state';
import { State } from '@ngxs/store';

export interface LibraryStateModel {
  isFetching: boolean;
}

@State<LibraryStateModel>({
  name: 'library',
  defaults: {
    isFetching: false,
  },
  children: [
    ColumnsState,
    SelectedTracksState,
    TracksState,
    RadioTagsState,
    FiltersState,
    TrackMixPointsState,
  ],
})
@Injectable()
export class LibraryState {}
